<template>
  <div>
    <template v-if="plan">
      <v-card max-width="724" flat class="mx-auto b-rad-20" color="neutral800">
        <v-card-title class="pa-5" style="font-size: 18px">
          {{ $t('PAYMENT.WORD.YOUR_ORDER') }}
        </v-card-title>
        <v-divider class="py-2"></v-divider>
        <v-card-text class="pa-5">
          <p
            style="font-size: 16px !important; color: #fff; line-height: 1"
            class="font-weight-bold mb-7"
          >
            {{ $t(plan.nameKey) }}
          </p>
          <v-row>
            <v-col cols="auto">
              <v-select
                :value="localPickedDay"
                :items="days"
                prepend-inner-icon="mdi-clock-outline"
                append-icon="mdi-chevron-down"
                @input="(v) => $emit('update:pickedDay', v)"
                background-color="neutral700"
                color=""
                :prefix="$t('PAYMENT.WORD.DURATION') + '：'"
                outlined
                dense
                class="plan-select"
              ></v-select>
            </v-col>
            <v-col>
              <Async :loading="isFetching" class="d-flex align-center price">
                <v-spacer></v-spacer>
                <span class="pr-3">{{ $t('COMMON.WORD.AMOUNT') }}</span>
                <span>NTD$</span>
                <span class="d-flex align-center">
                  <SizeBox width="10" inline />
                  <span>
                    {{ totalPrice }}
                  </span>
                </span>
              </Async>
              <div v-if="couponDetail.amount > 0" class="d-flex amount-root">
                <img class="cancel" src="@/assets/icons/x.svg" alt="" @click="cancelDiscount">
                <span class="amount">
                  -$&nbsp;{{ couponDetail.amount }}
                </span>
              </div>
            </v-col>
          </v-row>
          <v-btn
            class="d-flex coupon"
            height="40"
            color="neutral800"
            depressed
            @click="switchCouponToggle"
          >
            <img class="pr-1" src="@/assets/icons/discount-2.svg" alt="" />
            <span>使用優惠券</span>
          </v-btn>
          <SizeBox height="15" />
          <v-card
            v-if="Info && Info.originalRemainingDays"
            color="neutral500"
            class="mb-5"
          >
            <v-card-text class="d-flex">
              <v-icon class="mr-2">mdi-information</v-icon>
              <div class="font-weight-medium">
                {{
                  $t(
                    'COMMON.COPYWRITING.REMAINING_DAYS_PREVIOUS_PLAN_CONVERTED_INTO'
                  )
                }}
                <br />
                {{ $t('COMMON.COPYWRITING.REMAINING_DAYS_OF') }}
                {{ Info.originalTitle }}
                {{ $t('COMMON.COPYWRITING.REMAINING') }}
                {{ Info.originalRemainingDays }}
                {{ $t('COMMON.WORD.DAYS') }}
                {{ $t('COMMON.COPYWRITING.AFTER_CONVERTING_TO') }}
                {{ $t(plan.nameKey) }}
                <span class="text-h6 primary--text">
                  + {{ Info.convertedDays }}
                </span>
                {{ $t('COMMON.WORD.DAYS') }}
              </div>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
      <SizeBox height="24" />
      <v-card max-width="724" flat class="mx-auto b-rad-20" color="neutral800">
        <v-card-title class="pa-5" style="font-size: 18px">
          付款資訊
        </v-card-title>
        <v-divider class="py-2"></v-divider>

        <v-form ref="form" class="pa-5">
          <label for="email">
            {{ $t('PAYMENT.WORD.INVOICE_EMAIL') }}
            <span class="info-necessory">*</span>
          </label>
          <v-text-field
            name="email"
            outlined
            dense
            class="text-body-2"
            v-model="form.email"
            :placeholder="$t('PAYMENT.WORD.ENTER_EMAIL')"
            :height="36"
            :rules="[
              $rules.required,
              $t($rules.email),
              (v) =>
                !v.includes('+') || $t('PAYMENT.WORD.INVALID_EMAIL_ADDRESS')
            ]"
          ></v-text-field>
          <v-checkbox
            :label="$t('COMMON.WORD.TAX_ID')"
            v-model="isNeedInvoice"
          />
          <v-expand-transition>
            <div v-if="isNeedInvoice">
              <v-row class="d-flex justify-space-between">
                <v-col cols="12">
                  <label for="companyName">
                    {{ $t('PAYMENT.WORD.COMPANY_NAME') }}
                    <span class="info-necessory">*</span>
                  </label>
                  <v-text-field
                    outlined
                    dense
                    class="text-body-2"
                    :height="36"
                    :placeholder="$t('PAYMENT.COPYWRITING.ENTER_COMPANY_NAME')"
                    name="companyName"
                    v-model="form.companyName"
                    :rules="[$rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <label for="taxId">
                    {{ $t('PAYMENT.COPYWRITING.BUYER_TAX_ID') }}
                    <span class="info-necessory">*</span>
                  </label>
                  <v-text-field
                    outlined
                    dense
                    class="text-body-2"
                    :height="36"
                    :placeholder="$t('PAYMENT.COPYWRITING.TAX_ID')"
                    name="taxId"
                    v-model="form.taxId"
                    :rules="[$rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>
        </v-form>
      </v-card>
      <SizeBox height="24" />
      <div class="flex-center mx-auto purchase-btn">
        <v-btn
          color="primary"
          width="100%"
          height="40"
          depressed
          @click="submit"
        >
          {{ $t('PAYMENT.WORD.SUBMIT_PURCHASE') }}
        </v-btn>
      </div>
      <SizeBox height="40" />
      <div class="text-center text-subtitle-2" style="color: #a8a8a8">
        {{
          $t('PAYMENT.COPYWRITING.CONFIRMATION_PURCHASE_INDICATES_YOU_ACCEPT')
        }}
        <a
          target="_blank"
          href="https://hei-dong-chuang-zao.gitbook.io/virsody-shi-yong-he-yin-si-tiao-kuan/fu-fei-fu-wu-tiao-kuan"
        >
          {{ $t('PAYMENT.WORD.TERMS_OF_SERVICE') }}
        </a>
        {{ $t('COMMON.WORD.AND') }}
        <a
          target="_blank"
          href="https://hei-dong-chuang-zao.gitbook.io/virsody-shi-yong-he-yin-si-tiao-kuan/yin-si-quan-zheng-ce"
        >
          {{ $t('PAYMENT.WORD.PRIVACY_POLICY') }}
        </a>
        <br />
        {{ $t('PAYMENT.COPYWRITING.PAYMENTS_FOR_SERVICE_ARE_MADE') }}
        <a target="_blank" href="https://www.newebpay.com/">
          {{ $t('COMMON.WORD.NEWEBPAY') }}
        </a>
        {{ $t('PAYMENT.COPYWRITING.PLEASE_NOTE_THAT_NO_REFUND') }}
      </div>
    </template>
    <Coupon
      v-show="couponToggle"
      :dialog="couponToggle"
      @switchCouponToggle="switchCouponToggle"
      @closeCouponToggle="closeCouponToggle"
    />
  </div>
</template>

<script>
import Coupon from '@/components/plans/Coupon.vue';
import { estimateOrder } from '@/api/panel';
export default {
  props: {
    plan: {
      type: Object,
      default: null
    },
    planAlias: {
      type: String,
      default: null
    },
    pickedDay: {
      type: String,
      default: null
    },
    days: {
      type: Array,
      default: () => []
    }
  },
  components: { Coupon },
  data() {
    return {
      isNeedInvoice: false,
      isFetching: false,
      localPickedDay: this.pickedDay,
      Info: {},
      price: 0,
      form: {
        email: '',
        companyName: '',
        taxId: '',
        couponCode: ''
      },
      couponToggle: false,
      couponDetail: {
        title: '',
        amount: 0
      }
    };
  },

  watch: {
    pickedDay(v) {
      this.localPickedDay = v;
    },
    planAlias() {
      this.fetchExtraInfo();
    }
  },

  mounted() {
    this.fetchExtraInfo();
  },
  computed: {
    totalPrice() {
      return this.price - this.couponDetail.amount;
    }
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) return;

      const passData = { ...this.form };

      if (!this.isNeedInvoice) {
        delete passData.companyName;
        delete passData.taxId;
      }

      this.$emit('submit', this.form);
    },
    cancelDiscount() {
      this.couponDetail = {
        title: '',
        amount: 0
      }
      this.form.couponCode = '';
    },
    async fetchExtraInfo() {
      const lang = localStorage.getItem('language')
        ? localStorage.getItem('language').toLowerCase()
        : 'tw';
      this.isFetching = true;
      const Info = await estimateOrder({
        planAlias: this.planAlias,
        lang: lang
      });

      if (!Info.error && Info.isValid) {
        this.price = Info.totalPrice;
        this.Info = Info;
        this.form.email = Info.buyerEmail;
      } else {
        this.$emit('error');
        this.$toast.error(this.$t('PLAN.TOAST.ALERT.CANNOT_PURCHASE_PLAN'));
      }

      this.isFetching = false;
    },
    closeCouponToggle() {
      this.couponToggle = false;
    },
    switchCouponToggle(coupon) {
      this.couponToggle = !this.couponToggle;
      if (this.couponToggle == false) {
        this.couponDetail.amount = coupon.amount;
        this.couponDetail.title = coupon.title;
        this.form.couponCode = coupon.code;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
//
.plan-select {
  width: 220px;
  ::v-deep {
    fieldset {
      border: none;
    }
    .v-input__icon--prepend-inner {
      .v-icon.v-icon {
        font-size: 18px;
      }
    }
    .v-input__icon--append {
      .v-icon.v-icon {
        font-size: 24px;
      }
    }
    .v-select__slot {
      font-size: 14px;
    }
  }
}
.price {
  position: relative;
  color: #fff;

  span {
    font-size: 16px;
  }
}
.v-form {
  ::v-deep fieldset {
    background-color: #232323;
    border: none;
  }
  label {
    font-size: 14px;
    margin-bottom: 10px;
    display: block;
    color: #fff;
  }
}

.amount-root {
  justify-content: flex-end;
  margin-top: 12px;
  .cancel {
    cursor: pointer;
  }
  .amount {
    margin: 0;
    padding: 2px 11px;
    border-radius: 100px;
    display: inline-block;
    font-size: 14px !important;
    color: #66dfff;
    background-color: #005166;
  }
}
.coupon {
  letter-spacing: 0;
  span {
    color: $primary500;
  }
}

.info-necessory {
  color: #ff5084;
}

.purchase-btn {
  max-width: 724px;
}
</style>